import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isEmpty, cloneDeep } from 'lodash';
import * as action from '../store/POTemplate.action';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import { imageUrl } from '../../../../Components/helper';

const enterText = 'Enter Text';

const componenetSchema = {
  A_F_Details: [
    [
      {
        type: 'item',
        id: '1',
        fixed: true,
        field: 'supplierName',
        model: 'supplierName',
        key: 'Text',
        label: 'Supplier Name',
        enable: true,
        required: true,
      },
      {
        type: 'item',
        id: '2',
        fixed: true,
        field: 'supplierAddress',
        model: 'supplierAddress',
        key: 'Text_Area',
        label: 'Supplier Address',
        enable: true,
        required: true,
      },
      {
        type: 'item',
        id: '3',
        fixed: true,
        field: 'supplierCode',
        key: 'Text',
        model: 'supplierCode',
        label: 'Supplier Code',
        enable: true,
        required: true,
      },
      {
        type: 'item',
        id: '4',
        fixed: true,
        field: 'contactPersonsDetails',
        model: 'contactPersonsDetails',
        key: 'Dropdown',
        label: 'Supplier Contact Name',
        enable: true,
        required: true,
        options: [],
      },
      {
        type: 'item',
        id: '5',
        fixed: true,
        field: 'supplierContactEmail',
        model: 'supplierContactEmail',
        key: 'Text',
        label: 'Supplier Contact Email',
        enable: true,
        required: true,
      },
    ],
    [
      {
        type: 'item',
        id: '6',
        fixed: true,
        field: 'factoryName',
        onSelect: 'bindFactoryDetails',
        model: 'factoryName',
        key: 'Dropdown',
        label: 'Factory Name',
        enable: true,
        required: true,
        options: [],
      },
      {
        type: 'item',
        id: '7',
        fixed: true,
        field: 'factoryAddress',
        model: 'factoryAddress',
        key: 'Text_Area',
        label: 'Factory Address',
        enable: true,
        required: true,
      },
      {
        type: 'item',
        id: '8',
        fixed: true,
        field: 'factoryCode',
        model: 'factoryCode',
        key: 'Text',
        label: 'Factory Code',
        enable: true,
        required: true,
      },
      {
        type: 'item',
        id: '10',
        fixed: true,
        field: 'factContactPersonsDetails',
        model: 'factContactPersonsDetails',
        key: 'Dropdown',
        label: 'Factory Contact Name',
        enable: true,
        required: true,
        options: [],
      },
      {
        type: 'item',
        id: '11',
        fixed: true,
        field: 'factoryContactEmail',
        model: 'factoryContactEmail',
        key: 'Text',
        label: 'Factory Contact Email',
        enable: true,
        required: true,
      },
    ],
  ],
  Company_Details: [
    [
      {
        type: 'item',
        id: '1',
        uniqueId: '0',
        key: 'Dropdown',
        model: 'contactPersonList',
        onSelect: 'bindCompanyDetails',
        label: 'Contact Person Name',
        enable: true,
        required: true,
        options: [],
      },
      {
        type: 'item',
        id: '3',
        uniqueId: '1',
        key: 'Text',
        model: 'createdByName',
        label: 'Created By Name',
        enable: true,
        required: true,
      },
      {
        type: 'item',
        id: '5',
        uniqueId: '2',
        key: 'Text_Area',
        label: 'Billing Address',
        enable: true,
        required: true,
      },
    ],
    [
      {
        type: 'item',
        id: '2',
        uniqueId: '3',
        key: 'Text',
        model: 'email',
        label: 'Contact Person Email',
        enable: true,
        required: true,
      },
      {
        type: 'item',
        id: '4',
        uniqueId: '4',
        key: 'Text',
        model: 'createdByEmail',
        label: 'Created By Email',
        enable: true,
        required: true,
      },
      {
        type: 'item',
        id: '6',
        uniqueId: '5',
        key: 'Text_Area',
        label: 'Shipping Address',
        enable: true,
        required: true,
      },
    ],
  ],
  Supplier_Details: [
    [
      {
        type: 'item',
        id: '4',
        model: 'supplierName',
        key: 'Text',
        label: 'Supplier Name',
        enable: true,
        required: true,
      },
      {
        type: 'item',
        id: '4',
        model: 'supplierAddress',
        key: 'Text',
        label: 'Address1',
        enable: true,
        required: true,
      },
      {
        type: 'item',
        id: '4',
        model: 'supplierAddress',
        key: 'Text',
        label: 'Address1',
        enable: true,
        required: true,
      },
    ],
    [
      {
        type: 'item',
        id: '4',
        model: 'contactPersonPhone',
        key: 'Text_Area',
        label: 'Phone No',
        enable: true,
        required: true,
      },
      {
        type: 'item',
        id: '4',
        model: 'contactPersonsDetails',
        key: 'Dropdown',
        label: "Supplier's  Contact Person",
        enable: true,
        required: true,
        options: [{ name: 'Option 1' }],
      },
      {
        type: 'item',
        id: '4',
        model: 'contactPersonPhone',
        key: 'Dropdown',
        label: 'Phone No',
        enable: true,
        required: true,
        options: [{ name: 'Option 1' }],
      },
    ],
  ],
  Shipping_Details: [
    [
      {
        type: 'item',
        isStatic: true,
        disabled: true,
        id: '5',
        uniqueId: '1',
        key: 'Dropdown',
        label: 'Shipment Method',
        enable: true,
        required: true,
        options: [{ name: 'Air' }, { name: 'Sea' }, { name: 'Truck' }, { name: 'Sea and Truck' }],
      },
      {
        type: 'item',
        id: '12',
        uniqueId: '12',
        key: 'Ratio_Button',
        label: 'Shipping and Handling Cost Included?',
        enable: true,
        required: true,
        isStatic: true,
        disabled: true,
        options: [{ name: 'Yes' }, { name: 'No' }],
      },
      {
        type: 'item',
        isStatic: true,
        disabled: true,
        id: '6',
        uniqueId: '3',
        key: 'Text',
        label: 'Port of Landing',
        enable: true,
        required: true,
      },
    ],
    [
      {
        type: 'item',
        id: '4',
        uniqueId: '5',
        key: 'Dropdown',
        label: 'Incoterms',
        enable: true,
        required: true,
        isStatic: true,
        disabled: true,
        options: [
          { name: 'EXW (Ex Works)' },
          { name: 'FCA (Free Carrier)' },
          { name: 'FAS (Free Alongside Ship)' },
          { name: 'FOB (Free on Board)' },
          { name: 'CFR (Cost and Freight) ' },
          { name: 'CIF (Cost, Insurance and Freight)' },
          { name: 'CPT (Carriage Paid to) ' },
          { name: 'CIP (Carriage and Insurance Paid To)' },
          { name: 'DAT (Delivered at Terminal)' },
          { name: 'DAP (Delivered at Place)' },
          { name: 'DDP (Delivered Duty Paid)' },
        ],
      },
      {
        type: 'item',
        isStatic: true,
        disabled: true,
        id: '13',
        uniqueId: '13',
        key: 'Text',
        label: 'Shipping and Handling Cost',
        enable: true,
        required: true,
      },
      {
        type: 'item',
        isStatic: true,
        disabled: true,
        id: '6',
        uniqueId: '7',
        key: 'Text',
        label: 'Port of Lading',
        enable: true,
        required: true,
      },
    ],
  ],
  Terms_conditions: [
    [
      {
        type: 'item',
        id: '5',
        uniqueId: '0',
        key: 'Text_Area',
        label: 'Terms & Condition',
        placeholder: 'Terms & Condition',
        enable: true,
        required: false,
      },
    ],
    [],
  ],
};

const ratioPackJson = {
  type: 'Ratio_Pack',
  key: 'Ratio_Pack',
  id: '6',
  label: 'Ratio Packs',
  sigularPackedUnits: [{ singularPackedRows: [{}] }],
  multiplePacks: [{ multiplePackedRows: [{}] }],
  multipleTotalPacks: [{ multipleTotalPackedRows: [{}] }],
  ratioPacks: [{ leftColumn: [{}], rigthColumn: [{}] }],
  columns: [[], []],
};

const grandTotalJson = {
  type: 'container',
  isStatic: true,
  key: 'Grand_Total',
  id: '7',
  label: 'Grand Total',
  columns: [
    [
      {
        type: 'item',
        isStatic: true,
        id: '7',
        uniqueId: '0',
        showCurrency: true,
        key: 'Text',
        label: 'Grand Total Units',
        currency: '',
        placeholder: 'Grand Total Units',
        enable: true,
        disabled: true,
        required: false,
      },
      {
        type: 'item',
        isStatic: true,
        id: '6',
        uniqueId: '1',
        showCurrency: true,
        key: 'Text',
        isAfterDis: true,
        label: 'Grand Total Price (After Discount)',
        placeholder: 'Grand Total Price (After Discount)',
        disabled: true,
        currency: '',
        enable: true,
        required: false,
      },
    ],
    [
      {
        type: 'item',
        isStatic: true,
        id: '6',
        uniqueId: '3',
        key: 'Text',
        currency: '',
        showCurrency: true,
        label: 'Shipping Cost',
        placeholder: 'Shipping Cost',
        disabled: true,
        enable: true,
        required: false,
      },
    ],
  ],
};

const orderDetails = {
  type: 'container',
  isStatic: true,
  key: 'order_details',
  id: '14',
  label: 'Order Details',
};

let maxId = 5;

const shippingDetails = {
  type: 'container',
  isStatic: true,
  key: 'Shipping_Details',
  id: '2',
  label: 'Shipping Details',
  columns: componenetSchema.Shipping_Details,
};

const leftColumn = [
  {
    templates: [
      {
        type: 'container',
        key: 'A_F_Details',
        id: '1',
        label: 'Supplier/Factory Details',
        columns: componenetSchema?.A_F_Details,
      },
      {
        type: 'container',
        key: 'Company_Details',
        id: '3',
        label: 'Company Details',
        columns: componenetSchema?.Company_Details,
      },
    ],
  },
  {
    components: [
      {
        type: 'item',
        id: '5',
        key: 'Text_Area',
        label: 'Text Area',
        placeholder: enterText,
        enable: true,
        required: true,
      },
      {
        type: 'item',
        id: '6',
        key: 'Text',
        label: 'Textbox',
        placeholder: enterText,
        enable: true,
        required: true,
      },
      {
        type: 'item',
        id: '7',
        key: 'Dropdown',
        label: 'Dropdown',
        placeholder: 'Select Option',
        enable: true,
        required: true,
        options: [{ name: 'Option 1' }],
      },
      {
        type: 'item',
        id: '8',
        key: 'Check_Boxes',
        label: 'Checkbox',
        placeholder: '',
        enable: true,
        required: true,
        options: [{ name: 'Option 1' }],
      },
      {
        type: 'item',
        id: '9',
        key: 'Ratio_Button',
        label: 'Radio Button',
        placeholder: '',
        enable: true,
        required: true,
        options: [{ name: 'Option 1' }, { name: 'Option 2' }],
      },
      {
        type: 'container',
        key: 'Section',
        id: '4',
        label: 'Section',
        columns: [
          [
            {
              type: 'item',
              key: 'Div',
            },
          ],
          [
            {
              type: 'item',
              key: 'Div',
            },
          ],
        ],
      },
      {
        type: 'item',
        id: '10',
        key: 'Date_Picker',
        label: 'Date Picker',
        placeholder: '',
        enable: true,
        required: true,
      },
      {
        type: 'item',
        id: '11',
        key: 'Time_Picker',
        label: 'Time Picker',
        placeholder: '',
        enable: true,
        required: true,
      },
      {
        type: 'item',
        id: '12',
        key: 'Ratio_Button',
        label: 'Question Label',
        placeholder: '',
        enable: true,
        required: true,
        options: [{ name: 'Yes' }, { name: 'No' }],
      },
      {
        type: 'item',
        id: '13',
        key: 'Text_Area',
        label: 'Paragraph',
        placeholder: '',
        enable: true,
        required: true,
      },
    ],
  },
];

const models = {
  dropzones: [orderDetails, shippingDetails, ratioPackJson, grandTotalJson],
};

const initialState = {
  Loader: false,
  editPopup: false,
  editpopupData: null,
  editpopupChildData: null,
  editPopupIndex: -1,
  editPopupParentIndex: -1,
  editPopupChildIndex: -1,
  poDetails: {
    name: '',
    isActive: false,
    image: null,
    originalImg: null,
    nameErr: false,
  },
  rigthColumn: {
    name: '',
    nameErr: false,
    poOrderNo: null,
    visible: {
      singular: false,
      multiple: false,
      ratio: false,
      multipleTotalPacks: false,
    },
    image: null,
    originalImg: null,
    isActive: false,
    isDeleted: false,
    templateJsonSchema: [...(models.dropzones ?? [])],
  },
  leftColumn,
  reArrange: false,
};

export const StateContext = createContext(null);

export default function POTemplateStateProvider({ children }) {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { id } = useParams();

  const { t } = useTranslation('common');
  const {
    poTemplateData: { editData, compData, factData, custData, previewData },
  } = useSelector((reduxState) => reduxState);

  const [inSave, setInSave] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [poState, setPOState] = useState({ ...initialState });
  const [lengthEnabled, setLengthEnabled] = useState(true);

  const redirectToTemplateListing = async () => {
    setInSave(false);
    const initObj = { ...initialState };
    initObj.rigthColumn.templateJsonSchema = [orderDetails, shippingDetails, ratioPackJson, grandTotalJson];
    initObj.rigthColumn.visible = {
      singular: false,
      multiple: false,
      ratio: false,
      multipleTotalPacks: false,
    };
    initObj.leftColumn = [
      {
        templates: [
          {
            type: 'container',
            key: 'A_F_Details',
            id: '1',
            label: 'Supplier/Factory Details',
            columns: componenetSchema?.A_F_Details,
          },
          {
            type: 'container',
            key: 'Company_Details',
            id: '3',
            label: 'Company Details',
            columns: componenetSchema?.Company_Details,
          },
        ],
      },
      {
        components: [
          {
            type: 'item',
            id: '5',
            key: 'Text_Area',
            label: 'Text Area',
            placeholder: enterText,
            enable: true,
            required: true,
          },
          {
            type: 'item',
            id: '6',
            key: 'Text',
            label: 'Textbox',
            placeholder: enterText,
            enable: true,
            required: true,
          },
          {
            type: 'item',
            id: '7',
            key: 'Dropdown',
            label: 'Dropdown',
            placeholder: 'Select Option',
            enable: true,
            required: true,
            options: [{ name: 'Option 1' }],
          },
          {
            type: 'item',
            id: '8',
            key: 'Check_Boxes',
            label: 'Checkbox',
            placeholder: '',
            enable: true,
            required: true,
            options: [{ name: 'Option 1' }],
          },
          {
            type: 'item',
            id: '9',
            key: 'Ratio_Button',
            label: 'Radio Button',
            placeholder: '',
            enable: true,
            required: true,
            options: [{ name: 'Option 1' }, { name: 'Option 2' }],
          },
          {
            type: 'container',
            key: 'Section',
            id: '4',
            label: 'Section',
            columns: [
              [
                {
                  type: 'item',
                  key: 'Div',
                },
              ],
              [
                {
                  type: 'item',
                  key: 'Div',
                },
              ],
            ],
          },
          {
            type: 'item',
            id: '10',
            key: 'Date_Picker',
            label: 'Date Picker',
            placeholder: '',
            enable: true,
            required: true,
          },
          {
            type: 'item',
            id: '11',
            key: 'Time_Picker',
            label: 'Time Picker',
            placeholder: '',
            enable: true,
            required: true,
          },
          {
            type: 'item',
            id: '12',
            key: 'Ratio_Button',
            label: 'Question Label',
            placeholder: '',
            enable: true,
            required: true,
            options: [{ name: 'Yes' }, { name: 'No' }],
          },
          {
            type: 'item',
            id: '13',
            key: 'Text_Area',
            label: 'Paragraph',
            placeholder: '',
            enable: true,
            required: true,
          },
        ],
      },
    ];
    setPOState(JSON.parse(JSON.stringify({ ...initObj })));
    dispatch(action.clearReducer());
    history.push({
      pathname: '/libraries/po-template',
    });
  };
  const searchParams = new URLSearchParams(location?.search);
  const locaStates = location?.state;
  const stateLoa = searchParams.get('forAdd');
  const forAdd = locaStates?.forAdd || Boolean(stateLoa);
  const stateDuplicate = searchParams.get('forDuplication');
  const forDuplicate = locaStates?.forDuplication || Boolean(stateDuplicate);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('loggedInUserInfo'));
    if (userData?.lengthVisible !== null && userData?.lengthVisible !== undefined) {
      setLengthEnabled(userData?.lengthVisible);
    }
  }, []);

  useEffect(() => {
    if (id) {
      const callFn = async () => {
        await dispatch(action.fetchEditData(id));
      };
      callFn();
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (previewData) {
      const poPrevObj = {
        name: previewData?.code,
        image: previewData?.image,
        originalImg: previewData?.originalImg,
        isActive: previewData?.isActive,
      };
      const rightPrevObje = { ...previewData };
      setPOState((prevData) => ({
        ...prevData,
        rigthColumn: rightPrevObje,
        poDetails: poPrevObj,
      }));
    }
    if (editData && !isEmpty(editData) && !forAdd) {
      const poObj = {
        name: editData?.name,
        image: editData?.image,
        originalImg: editData?.originalImg,
        isActive: editData?.isActive,
      };
      delete editData?.name;
      delete editData?.image;
      delete editData?.isActive;
      delete editData?.originalImg;

      const newLeftcolumn = cloneDeep(leftColumn);
      const fileredSections = editData?.templateJsonSchema?.filter((e) => e?.key === 'Section');
      if (fileredSections?.length > 0) {
        const biggestId = fileredSections.map((e) => Number(e.id));
        maxId = Math.max(...biggestId);
        newLeftcolumn[1].components[5] = {
          type: 'container',
          key: 'Section',
          id: incrementCounter(),
          label: 'Section',
          columns: [
            [
              {
                type: 'item',
                key: 'Div',
              },
            ],
            [
              {
                type: 'item',
                key: 'Div',
              },
            ],
          ],
        };
      }
      const rightObje = { ...editData };
      setPOState((prevData) => ({
        ...prevData,
        rigthColumn: rightObje,
        poDetails: poObj,
        leftColumn: newLeftcolumn,
      }));
    }
  }, [editData, location, previewData]);

  const incrementCounter = () => {
    maxId += 1;
    return Number(maxId) + 1;
  };

  const duplicatingItem = (index, i, key, fromCustomSection) => {
    const rightSide = cloneDeep(poState?.rigthColumn);
    rightSide?.templateJsonSchema?.map((ele) => {
      if (fromCustomSection ? ele?.id.toString() === key?.toString() : ele.key === key) {
        const item = ele?.columns[index][i];
        ele?.columns[index]?.splice(i, 0, {
          ...item,
          addingNew: true,
          id: incrementCounter(),
        });
      }
      return ele;
    });
    setPOState((oldState) => ({
      ...oldState,
      rigthColumn: rightSide,
    }));
  };

  const deleteItem = (index, i, key, mainIndex) => {
    const rightSide = cloneDeep(poState?.rigthColumn);
    rightSide?.templateJsonSchema?.map((ele, eleIndex) => {
      if (eleIndex === mainIndex) {
        ele.key === key && ele.columns[index].splice(i, 1);
      }
      return ele;
    });
    setPOState((oldState) => ({
      ...oldState,
      rigthColumn: rightSide,
    }));
  };

  const editingInput = (index, i, foundIndex) => {
    const rightSide = cloneDeep(poState?.rigthColumn);
    const editPopupChildValue = rightSide?.templateJsonSchema[foundIndex]?.columns[index][i];
    setPOState((oldState) => ({
      ...oldState,
      editPopup: true,
      editpopupData: rightSide?.templateJsonSchema[foundIndex],
      editpopupChildData: editPopupChildValue,
      editPopupIndex: index,
      editPopupParentIndex: foundIndex,
      editPopupChildIndex: i,
    }));
  };

  const changeLabel = (element, index) => {
    const editPopupValue = { ...element, forLabel: true };
    setPOState((oldState) => ({
      ...oldState,
      editPopup: true,
      editpopupData: editPopupValue,
      editPopupIndex: index,
    }));
  };

  const dropLocation = (index, item, id) => {
    const updatedLeft = cloneDeep(poState?.leftColumn);
    const newObject = poState?.rigthColumn;
    if (item?.type === 'container') {
      toggleEditPopup();
      if (item.key === 'Section') {
        updatedLeft?.map((ele) => {
          ele?.components?.map((element) => {
            if (element?.id === item?.id) {
              element.id = incrementCounter();
            }
            return element;
          });
          return ele;
        });
      } else {
        updatedLeft?.map((ele) => {
          ele?.templates?.map((element) => {
            if (element?.id === item?.id) {
              element.id = incrementCounter();
            }
            return element;
          });
          return ele;
        });
      }
      const rightSideKeys = newObject?.templateJsonSchema.map((ele) => ele?.key);
      const arrayToCheck = rightSideKeys.filter((ele) => ['Company_Details', 'A_F_Details'].includes(ele));
      const hasItemAlready = arrayToCheck.includes(item?.key);
      if (hasItemAlready) {
        toasterMsg(`There can be only 1 ${item?.label} in the P.O.Template`, 'danger');
      } else {
        newObject?.templateJsonSchema?.splice(index, 0, item);
      }
    }

    setPOState((oldState) => ({
      ...oldState,
      rigthColumn: newObject,
      leftColumn: updatedLeft,
    }));
  };

  const dropInLocation = (i, index, item, id, elementIndex) => {
    const newObject = poState?.rigthColumn;
    const parentIndex = elementIndex || newObject?.templateJsonSchema?.findIndex((ele) => ele.id === id);
    if (parentIndex !== -1) {
      toggleEditPopup();
      const leftCol = cloneDeep(poState?.leftColumn);
      leftCol?.map((ele) => {
        ele?.components?.map((element) => {
          if (element?.id === item?.id) {
            element.id = incrementCounter();
          }
          return element;
        });
        return ele;
      });
      newObject.templateJsonSchema?.[parentIndex]?.columns?.[index]?.splice(i, 0, {
        ...item,
        addingNew: true,
        id: incrementCounter(),
      });
      setPOState((previousState) => ({
        ...previousState,
        rigthColumn: newObject,
        leftColumn: leftCol,
      }));
    }
  };

  const handleShowRearrangeModal = () => {
    setPOState((otherState) => ({
      ...otherState,
      reArrange: !poState.reArrange,
    }));
  };

  const handleSaveSequence = async (_e, sequenceList) => {
    const rCol = poState?.rigthColumn;
    rCol.templateJsonSchema = sequenceList?.sequence;
    setPOState((oldEle) => ({
      ...oldEle,
      rigthColumn: rCol,
    }));
    handleShowRearrangeModal();
  };

  useEffect(() => {
    if (
      !isEmpty(custData) &&
      custData?.length === poState?.rigthColumn?.templateJsonSchema?.filter((e) => e?.key === 'Section' || e?.key === 'Terms_conditions')?.length &&
      compData &&
      factData
    ) {
      const saveApiCall = async () => {
        if (!poState?.poDetails?.name) {
          const rightData = cloneDeep(poState?.poDetails);
          rightData.nameErr = true;
          setPOState((allElement) => ({ ...allElement, poDetails: rightData }));
          // optional feture
          toasterMsg('Please fill all the required fileds.', 'danger');
        } else {
          const stringgedData = JSON.stringify(poState?.rigthColumn?.visible);
          if (stringgedData.includes('true')) {
            setPOState((oldState) => ({ ...oldState, Loader: true }));
            poState?.rigthColumn?.templateJsonSchema?.map((ele) => {
              if (ele?.key === 'Section') {
                const newColumns = ele?.columns?.map((arrEle) => {
                  return arrEle.filter((e) => e.id);
                });
                return { ...ele, columns: newColumns };
              }
              if (ele?.key === 'Company_Details') {
                return { ...compData };
              }
              if (ele?.key === 'A_F_Details') {
                return { ...factData };
              }
              if (ele?.key === 'Terms_conditions') {
                return {
                  ...custData?.find((e) => e?.key === 'Terms_conditions'),
                };
              }
              if (ele?.key === 'Section') {
                return {
                  ...custData?.find((e) => e?.key === 'Section'),
                };
              }
              return ele;
            });
            const params = {
              image: poState?.poDetails?.image,
              name: poState?.poDetails?.name,
              isActive: poState?.poDetails?.isActive,
              isDeleted: false,
              templateJsonSchema: JSON.stringify(poState?.rigthColumn?.templateJsonSchema),
              visible: poState?.rigthColumn?.visible,
            };
            if (id) {
              params.isDeleted = false;
              params.createdBy = poState?.rigthColumn?.createdBy;
              params.createdAt = poState?.rigthColumn?.createdAt;
              params.modifiedBy = poState?.rigthColumn?.modifiedBy;
              params.lastModifiedAt = poState?.rigthColumn?.lastModifiedAt;
              if (!forDuplicate) params._id = id;
            }
            let res = false;

            if (id && !forDuplicate) {
              res = await dispatch(action.updatePOTemp(params, t));
            } else {
              res = await dispatch(action.postPOTemp(params, t));
            }
            if (res?.code === 200) {
              redirectToTemplateListing();
            } else {
              setInSave(false);
              setPOState((allElement) => ({
                ...allElement,
                Loader: false,
              }));
            }
          } else {
            toasterMsg('Please select atleast one pack unit to create P.O.Template', 'danger');
          }
        }
      };
      saveApiCall();
    } else if (inSave) {
      const elseSaveApiCall = async () => {
        if (!poState?.poDetails?.name) {
          const rightData = cloneDeep(poState?.poDetails);
          rightData.nameErr = true;
          setPOState((allElement) => ({
            ...allElement,
            poDetails: rightData,
          }));
          // optional feture
          toasterMsg('Please fill all the required fileds.', 'danger');
        } else {
          const stringgedData = JSON.stringify(poState?.rigthColumn?.visible);
          if (stringgedData.includes('true')) {
            setPOState((oldState) => ({ ...oldState, Loader: true }));
            poState?.rigthColumn?.templateJsonSchema?.map((ele) => {
              if (ele?.key === 'Section') {
                const newColumns = ele?.columns?.map((arrEle) => {
                  return arrEle.filter((e) => {
                    delete e?.forLabel;
                    return e.id;
                  });
                });
                delete ele?.forLabel;
                return { ...ele, columns: newColumns };
              }
              const updatedColumns = ele?.columns?.map((col) => {
                const updatedElement = col?.map((element) => {
                  delete element?.forLabel;
                  return element;
                });
                return [...updatedElement];
              });
              delete ele?.forLabel;
              return { ...ele, columns: updatedColumns };
            });
            const params = {
              image: poState?.poDetails?.image,
              name: poState?.poDetails?.name,
              isActive: poState?.poDetails?.isActive,
              isDeleted: false,
              templateJsonSchema: JSON.stringify(poState?.rigthColumn?.templateJsonSchema),
              visible: poState?.rigthColumn?.visible,
            };
            if (id) {
              params.isDeleted = false;
              params.createdBy = poState?.rigthColumn?.createdBy;
              params.createdAt = poState?.rigthColumn?.createdAt;
              params.modifiedBy = poState?.rigthColumn?.modifiedBy;
              params.lastModifiedAt = poState?.rigthColumn?.lastModifiedAt;
              if (!forDuplicate) params._id = id;
            }
            let res = false;
            if (id && !forDuplicate) {
              setInSave(false);
              res = await dispatch(action.updatePOTemp(params, t));
            } else {
              res = await dispatch(action.postPOTemp(params, t));
            }
            if (res?.code === 200) {
              redirectToTemplateListing();
            } else {
              setInSave(false);
              setPOState((allElement) => ({
                ...allElement,
                Loader: false,
              }));
            }
          } else {
            toasterMsg('Please select atleast one pack unit to create P.O.Template', 'danger');
          }
        }
      };
      elseSaveApiCall();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [compData, factData, custData, inSave, dispatch, id]);
  const handleSave = async () => {
    setInSave(true);
  };

  const deleteCard = (index) => {
    const object = cloneDeep(poState?.rigthColumn);
    object?.templateJsonSchema?.splice(index, 1);
    setPOState((otherStates) => ({
      ...otherStates,
      rigthColumn: object,
    }));
  };

  const modfiyReqAndEnable = (item, index) => {
    setPOState((otherStates) => ({
      ...otherStates,
      editPopup: true,
      editpopupData: item,
      editPopupIndex: index,
    }));
  };

  const toggleEditPopup = () => {
    setPOState((otherStates) => ({
      ...otherStates,
      editPopup: false,
      editpopupData: null,
      editpopupChildData: null,
      editPopupIndex: -1,
      editPopupParentIndex: -1,
      editPopupChildIndex: -1,
    }));
  };

  const changeData = (obj, i) => {
    const updatedArray = cloneDeep(poState.rigthColumn);
    if (poState.editPopupIndex !== -1) {
      if (poState.editPopupChildIndex !== -1) {
        updatedArray.templateJsonSchema[poState?.editPopupParentIndex].columns[poState?.editPopupIndex][poState?.editPopupChildIndex] = obj;
      } else {
        updatedArray.templateJsonSchema[i] = obj;
      }
    }
    setPOState((oldData) => ({
      ...oldData,
      editPopup: false,
      editpopupData: null,
      editpopupChildData: null,
      editPopupIndex: -1,
      editPopupParentIndex: -1,
      editPopupChildIndex: -1,
      rigthColumn: updatedArray,
    }));
  };

  const onChangeForData = (e, name) => {
    const right = cloneDeep(poState.poDetails);
    if (name === 'PO_Template_Button') {
      right.isActive = e;
    } else if (name === 'template_name') {
      setInSave(false);
      right.name = e?.target?.value;
      setInSave(false);
    } else {
      setShowUpload(true);
    }
    setPOState((previousData) => ({
      ...previousData,
      poDetails: right,
    }));
  };

  const onChange = (value, label, i, eleIndex, index) => {
    const template = poState.rigthColumn;
    template.templateJsonSchema[eleIndex].columns[index][i].value = value;
    setPOState((previosState) => ({
      ...previosState,
      rigthColumn: template,
    }));
  };

  const forSwitch = (e) => {
    const obj = poState.rigthColumn;
    switch (e?.target?.name) {
      case 'singleSwitch':
        obj.visible.singular = e?.target?.checked;
        break;
      case 'multiSingleSizeSwitch':
        obj.visible.multiple = e?.target?.checked;
        break;
      case 'MultiSizeSwitch':
        obj.visible.multipleTotalPacks = e?.target?.checked;
        break;

      default:
        obj.visible.ratio = e?.target?.checked;
        break;
    }
    setInSave(false);
    setPOState((singleSw) => ({ ...singleSw, rigthColumn: obj }));
  };

  const ifNotBase64Image = () => {
    return poState?.poDetails?.image ? `${imageUrl}/${poState?.poDetails?.image}` : '';
  };
  const imageSrc = () => {
    return poState?.poDetails?.image?.includes('base64') ? poState?.poDetails?.image : ifNotBase64Image();
  };

  const contextValue = useMemo(
    () => ({
      showUpload,
      duplicatingItem,
      deleteItem,
      editingInput,
      changeLabel,
      dropLocation,
      dropInLocation,
      handleSaveSequence,
      imageSrc,
      handleSave,
      deleteCard,
      modfiyReqAndEnable,
      changeData,
      onChangeForData,
      onChange,
      forSwitch,
      setShowUpload,
      poState,
      setPOState,
      initialState,
      handleShowRearrangeModal,
      redirectToTemplateListing,
      toggleEditPopup,
      inSave,
      lengthEnabled,
    }),
    [
      showUpload,
      duplicatingItem,
      deleteItem,
      editingInput,
      changeLabel,
      dropLocation,
      dropInLocation,
      handleSaveSequence,
      imageSrc,
      handleSave,
      deleteCard,
      modfiyReqAndEnable,
      changeData,
      onChangeForData,
      onChange,
      forSwitch,
      setShowUpload,
      poState,
      setPOState,
      initialState,
      handleShowRearrangeModal,
      redirectToTemplateListing,
      toggleEditPopup,
      inSave,
      lengthEnabled,
    ],
  );
  return (
    <StateContext.Provider
      value={{
        ...contextValue,
      }}
    >
      {children}
    </StateContext.Provider>
  );
}

export function usePOTemplateState() {
  const context = useContext(StateContext);
  if (!context) {
    throw new Error('useAppState must be used within the POTemplateStateProvider');
  }
  return context;
}
